// extracted by mini-css-extract-plugin
module.exports = {"header":"GlobalEventTemplateManagement_header__DoND5","search":"GlobalEventTemplateManagement_search__1ogZP"};